import { useSelector } from "react-redux";

import { getEnvVal } from "core/env.js";

import CustomDndCell from "./components/CustomCell/CustomDndCell";
import CustomExportProtocolCell from "./components/CustomCell/CustomExportProtocolCell";
import CustomNavigateCell from "./components/CustomCell/CustomNavigateCell";
import CustomNorthTerrCell from "./components/CustomCell/CustomNorthTerrCell";
import CustomUserCell from "./components/CustomCell/CustomUserCell";

export default function ProjectTableColumns({ funcs, rowsDataHasPack, tableData }) {
	const userPermissions = useSelector((state) => state.auth.permissions);
	const windowWidth = useSelector((state) => state.windowDimensions.windowWidth);
	const tableFiltering = useSelector((state) => state.projects.table.viewParams.filter);

	const getCodeWidth = () => {
		if (windowWidth > 1200) return "200px";
		return "110px";
	};

	const getPzWidth = () => {
		if (windowWidth > 1200) return "250px";
		return "125px";
	};

	const getTerWidth = () => {
		if (windowWidth > 1200) return "150px";
		return "95px";
	};

	const getUserWidth = () => {
		if (windowWidth > 1200) return "250px";
		return "220px";
	};

	const columns = [
		{
			name: "dnd",
			title: "",
			width: "15px",
			cellHorAlign: "left",
			headHorAlign: "left",
			cellJsx: ({ rowObj }) => <CustomDndCell rowObj={rowObj} funcs={funcs} />,
		},
		{
			name: "code",
			title: "Код",
			width: getCodeWidth(),
			cellHorAlign: "left",
			headHorAlign: "left",
			sort: true,
			filter: true,
			editable: true,
			advancedFilter: false,
			highlightSubstring: tableFiltering?.code,
		},
		{
			name: "name",
			title: "Наименование проекта",
			width: "auto",
			cellHorAlign: "left",
			headHorAlign: "left",
			sort: true,
			filter: true,
			filterWidth: "200px",
			filterAlwaysOpen: true,
			editable: true,
			advancedFilter: false,
			colSpan: 2,
			highlightSubstring: tableFiltering?.name,
		},
		{
			name: "action_navigate",
			title: "",
			width: "10px",
			cellHorAlign: "center",
			headHorAlign: "center",
			sort: false,
			filter: false,
			editable: false,
			cellJsx: ({ rowObj }) => <CustomNavigateCell rowObj={rowObj} funcs={funcs} />,
		},
		{
			name: "price_zone_id",
			title: "Ценовая зона",
			width: getPzWidth(),
			cellHorAlign: "left",
			headHorAlign: "left",
			sort: false,
			filter: true,
			editable: true,
			advancedFilter: false,
			selecting: "price_zones",
			highlightSubstring: tableFiltering?.price_zone_id,
		},
		{
			name: "north_reg_terr_id",
			title: "Признак территории",
			width: getTerWidth(),
			cellHorAlign: "left",
			headHorAlign: "left",
			sort: false,
			filter: false,
			editable: true,
			selecting: "north_reg_terrs",
			cellJsx: ({ rowObj }) => <CustomNorthTerrCell rowObj={rowObj} funcs={funcs} />,
		},
		{
			name: "date_create",
			title: "Дата создания",
			width: "130px",
			cellHorAlign: "left",
			headHorAlign: "left",
			sort: true,
			filter: false,
			editable: false,
		},
		{
			name: "export_protocol",
			title: "",
			width: "10px",
			cellHorAlign: "left",
			headHorAlign: "left",
			sort: false,
			filter: false,
			editable: false,
			cellJsx: ({ rowObj }) => <CustomExportProtocolCell rowObj={rowObj} funcs={funcs} />,
		},
	];

	if (!userPermissions.is_guest) {
		columns.push({
			name: "username",
			title: "Пользователь",
			width: getUserWidth(),
			cellHorAlign: "left",
			headHorAlign: "left",
			sort: true,
			filter: true,
			editable: false,
			advancedFilter: false,
			cellJsx: ({ rowObj, funcs }) => (
				<CustomUserCell rowObj={rowObj} funcs={funcs} tableData={tableData} highlight={tableFiltering?.username} />
			),
		});
	}

	if (userPermissions.is_life_map_user) {
		columns.splice(5, 0, {
			name: "city_id",
			title: "Населенный пункт",
			width: getPzWidth(),
			cellHorAlign: "left",
			headHorAlign: "left",
			sort: false,
			filter: false,
			editable: true,
			selecting: "price_zones",
			findSelecting: {
				optFindAttr: "id",
				optFindAttrVal: {
					rowObjAttr: "price_zone_id",
				},
				optNewOptsAttr: "cities",
			},
		});
	}

	if (getEnvVal("App") === "sipcs") {
		return columns.filter((clm) => clm.name !== "north_reg_terr_id");
	}

	if (rowsDataHasPack === false) {
		return columns.filter((clm) => clm.name !== "dnd");
	}

	return columns;
}
